import React from 'react'
import StatCard from './StatCard'
import VenueCard from './VenueCard'

const ArtistStatsDisplay = ({ artistStats, selectedArtist }) => {
  if (!artistStats) return null

  return (
    <div className="space-y-6">
      <div className="bg-white/5 rounded-xl p-6 border border-white/10">
        <h3 className="text-lg font-semibold text-white mb-4">📍 Where You've Seen {selectedArtist}</h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <StatCard
            value={artistStats.timesSeenCount}
            label="Times Seen"
            variant="purple"
          />
          <StatCard
            value={artistStats.venues.length}
            label="Different Venues"
            variant="blue"
          />
        </div>

        {artistStats.venues.length > 0 && (
          <div>
            <h4 className="text-white font-medium mb-3">Venues & Events:</h4>
            <div className="space-y-2">
              {artistStats.venues.map((venue, index) => (
                <VenueCard key={index} venue={venue} />
              ))}
            </div>
          </div>
        )}

        {artistStats.upcomingEvents && artistStats.upcomingEvents.length > 0 && (
          <div className="mt-6">
            <h4 className="text-white font-medium mb-3">🔮 Upcoming Events:</h4>
            <div className="space-y-2">
              {artistStats.upcomingEvents.map((event, index) => (
                <div key={index} className="bg-green-500/10 rounded-lg p-3 border border-green-500/30">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-green-200 font-medium">{event.name}</div>
                      <div className="text-green-300 text-sm">{event.venueName}, {event.country}</div>
                    </div>
                    <div className="text-green-200 text-sm">
                      {new Date(event.startDate).toLocaleDateString()}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ArtistStatsDisplay